import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import preferences from "@coworker/enums/profilePreferences";
import useProductQualityFilter from "./useProductQualityFilter";
import { User } from "@coworker/apprestructured/src/shared/types/user";
import useRolesMultiSelectFilter from "./useRolesMultiSelectFilter";
import { useSortByFilter } from "./useTeamsSortByFilter";

const useTeamsFilters = (users: User[], userTabActive: boolean) => {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.TEAMS_FILTERS
  );

  const useTeamsDataFilters = () => [
    useProductQualityFilter(!userTabActive),
    useRolesMultiSelectFilter(userTabActive, users, userTabActive),
    useSortByFilter(filterValues, !userTabActive),
  ];

  const resetFilters = () => {
    setFilterValues([]);
  };

  return {
    useFiltersFactory: useTeamsDataFilters,
    filterValues,
    setFilterValues,
    resetFilters,
  };
};

export default useTeamsFilters;
